import {getServerTexts as getTexts, initTexts, texts} from '../../../Localization/texts';

const entity = 'UI_EMPTYSTATE';

const en = {
    noResults: 'Sorry, no results matched your filter condition',
    noRecords: 'Your list is empty right now',
    moreResultsMessage: 'To find more results, try expanding the search criteria',
    addNewMessage: 'Add new data by clicking the New button.',
    filterDataMessage:
        'Find your data by using Filters which appear when you mouse over column headers.'
};

const he = {
    noResults: 'אין נתונים המתאימים לחיפוש',
    noRecords: 'הרשימה ריקה כרגע',
    moreResultsMessage: 'כדי למצוא תוצאות, יש להרחיב את טווח החיפוש',
    addNewMessage: 'להוספת נתונים חדשים אפשר להשתמש בכפתור חדש.',
    filterDataMessage: 'להצגת נתונים אפשר להשתמש בפילטרים המופיעים במעבר עכבר מעל כותרות העמודות.'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'noResults',
    2: 'noRecords',
    3: 'moreResultsMessage',
    4: 'addNewMessage',
    5: 'filterDataMessage'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
